<template>
  <header class="award-ranking-header-section">
    <div class="award-ranking-header-section__inner">
      <img
        class="award-ranking-header-section__bg"
        :src="require('@/assets/img/AwardPage/icon_cup.svg')"
        alt=""
      />
      <h3 class="award-ranking-header-section__title">
        <i><img :src="require('@/assets/img/AwardPage/icon_driver.svg')" alt="" /></i>
        {{ title }}
      </h3>
      <p
        v-if="description"
        class="award-ranking-header-section__description"
        v-text="description"
      />
    </div>
  </header>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * SFgo Award ランキングヘッダーセクション
 */
export default defineComponent({
  name: 'AwardRankingHeaderSection',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.award-ranking-header-section {
  width: 100%;
  padding: 14px;
  background: rgba(255, 255, 255, 0.3);
  font-family: $fontSignup;

  img {
    display: block;
  }

  &__inner {
    position: relative;
    display: flex;
    width: 100%;
    padding: 25px 0;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: 10px;
    background: linear-gradient(96deg, #fcd983 15%, #ba6e2b 100%);
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;

    &::before {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      content: '';
      width: 100%;
      border: 2px solid rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }
  }

  &__bg {
    position: absolute;
    right: 0;
    bottom: -2px;
    width: 83px;
  }

  &__title {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    width: 100%;
    font-size: 18px;
    font-weight: 700;
    line-height: 1;
    color: $black;

    img {
      width: 18px;
    }
  }

  &__description {
    padding: 0 1em;
    color: $black70;
    text-align: center;
    @include fontSetTextMedium();
  }
}
</style>
